import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import NumberFormat from "react-number-format";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import SuiAvatar from "components/SuiAvatar";
import SuiBadge from "components/SuiBadge";
import ConversationList from "components/UpStyled/Conversations";
import ReadMore from "components/UpStyled/ReadMore";
import Tooltip from "@mui/material/Tooltip";

import MarkChatReadIcon from "@mui/icons-material/MarkChatRead";
import toast from "react-hot-toast";
import moment from "moment";
import { capitalCase } from "capital-case";
import { MANUFACTURER_SERVICES } from "utils/data";
import { filterParser } from "utils/helper";
import { AccountContext } from "context/account";

import FilePreviewCard from "components/UpStyled/FilePreviewCard";
import api from "services/api";

const ResponseStatus = ({ project }) => {
  const [maList, setMaList] = useState([]);

  const user = useContext(AccountContext);

  useEffect(() => {
    if (user.id && user.role == "admin") {
      const audiences = project?.audiences || [];
      retrieveManufacturerList(audiences);
    }
  }, [project.id, user.id]);

  const retrieveManufacturerList = async (audiences) => {
    const responseMap = project?.response || {};
    const manufacturers = Object.keys(responseMap);

    if (manufacturers && manufacturers.length > 0) {
      let payload = { sort: ["account_status:asc"], offset: 0, limit: 100 };
      payload["q"] = "";

      let myFilter = { account_type: "ma", id: { eq: manufacturers } };

      const newFilterStr = filterParser(myFilter);
      if (newFilterStr) {
        payload["filter"] = newFilterStr;
      }
      const { data } = await api.users.search(payload);

      setMaList(data ? data : []);
    }
  };

  const responseMap = project?.response || {}; //{manufacturer_id:{date:xxx,message:xxx}}

  return (
    <div>
      <Card sx={{ px: 3, py: 2, minHeight: "100%" }}>
        <div className="flex flex-wrap justify-between">
          <SuiBox key={"project-info"} display="flex" className="gap-1 items-center">
            <SuiTypography variant="h6" fontWeight="bold" textTransform="capitalize">
              Response Status
            </SuiTypography>
          </SuiBox>
        </div>

        <SuiBox key={"sent requests"} py={1} pr={2} className="gap-1 items-start">
          <SuiTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
            sx={{ whiteSpace: "nowrap" }}
          >
            Replied Manufacturers:
          </SuiTypography>
          {maList?.hits && maList?.hits.length > 0 ? (
            <List sx={{ width: "100%", bgcolor: "background.paper" }}>
              {maList.hits.map((user) =>
                user?.stores && user.stores.length > 0 ? (
                  <ListItem alignItems="flex-start" sx={{ mb: 0.5 }}>
                    <ListItemAvatar>
                      <Link to={`/wall/portfolio/${user.id}`}>
                        <Tooltip position="top" title={user.stores[0]?.name}>
                          <SuiAvatar
                            src={user.stores[0]?.metadata?.avatar}
                            alt="profile-image"
                            variant="circle"
                            size="xs"
                            shadow="sm"
                          />
                        </Tooltip>
                      </Link>
                    </ListItemAvatar>

                    <ListItemText
                      primary={user.stores[0]?.name}
                      secondary={
                        <React.Fragment>
                          {responseMap[user.id]?.date
                            ? moment(responseMap[user.id]?.date).format("YYYY-MM-DD HH:mm:ss")
                            : ""}
                          <ReadMore limit={200} variant="body2" textTransform="none" color="text">
                            {responseMap[user.id]?.message}
                          </ReadMore>
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                ) : null
              )}
            </List>
          ) : (
            <SuiTypography color="secondary">No manufacturers reply to this project!</SuiTypography>
          )}
        </SuiBox>
      </Card>
    </div>
  );
};

export default ResponseStatus;
